import { MARD_291 } from './palette';
import type { PatternProject } from '../types';

function hasPreviewMime(value: string, mime: 'webp' | 'jpeg' | 'png') {
  return value.startsWith(`data:image/${mime};base64,`);
}

export async function createGalleryPreview(project: PatternProject) {
  const source = document.createElement('canvas');
  source.width = project.width;
  source.height = project.height;
  const sourceContext = source.getContext('2d');
  if (!sourceContext) throw new Error('浏览器无法生成图纸预览');
  const image = sourceContext.createImageData(project.width, project.height);
  for (let index = 0; index < project.colorIndices.length; index += 1) {
    const offset = index * 4;
    if (project.empty[index]) continue;
    const hex = MARD_291[project.colorIndices[index]]?.hex || '#ffffff';
    const value = Number.parseInt(hex.slice(1), 16);
    image.data[offset] = (value >> 16) & 255;
    image.data[offset + 1] = (value >> 8) & 255;
    image.data[offset + 2] = value & 255;
    image.data[offset + 3] = 255;
  }
  sourceContext.putImageData(image, 0, 0);

  const size = 360;
  const preview = document.createElement('canvas');
  preview.width = size;
  preview.height = size;
  const context = preview.getContext('2d');
  if (!context) throw new Error('浏览器无法生成图纸预览');
  context.fillStyle = '#fffdf8';
  context.fillRect(0, 0, size, size);
  const scale = Math.min((size - 32) / project.width, (size - 32) / project.height);
  const width = project.width * scale;
  const height = project.height * scale;
  context.imageSmoothingEnabled = false;
  context.drawImage(source, (size - width) / 2, (size - height) / 2, width, height);
  const webp = preview.toDataURL('image/webp', 0.82);
  if (hasPreviewMime(webp, 'webp')) return webp;
  const jpeg = preview.toDataURL('image/jpeg', 0.86);
  if (hasPreviewMime(jpeg, 'jpeg')) return jpeg;
  const png = preview.toDataURL('image/png');
  if (hasPreviewMime(png, 'png')) return png;
  throw new Error('当前浏览器无法生成兼容的图纸预览，请升级浏览器后重试');
}
